export interface StatusOption {
  id: string;
  label: string;
  isArchived?: boolean;
}

export interface ValuationStatusTrackerProps {
  statusOptions: StatusOption[];
  currentStatusId?: string;
  onStatusChange?: (statusId: string) => void;
  isLoading?: boolean;
  disabled?: boolean;
  isExpanded?: boolean;
}

export enum StepStatus {
  ACTIVE = 'active',
  COMPLETED = 'completed',
  PENDING = 'pending',
}
